<!-- Modern MARC Button -->
<button type="button" class="btn btn-light btn-light-walai border rounded-pill py-2 " data-bs-toggle="modal"
  data-bs-target="#marcModal">
  <i class="bi bi-file-earmark-text me-2"></i>
  <span>{{'MARC Record' | translate}}</span>
</button>

<!-- Modern MARC Modal -->
<div class="modal fade" id="marcModal" tabindex="-1" aria-labelledby="marcModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen-md-down modal-xl modal-dialog-scrollable">
    <div class="modal-content border-0 shadow-lg">

      <!-- Modal Header -->
      <div class="modal-header bg-light border-0 py-3">
        <div class="d-flex align-items-center gap-3">
          <div class="marc-icon-wrapper">
            <i class="bi bi-file-earmark-text text-primary fs-4"></i>
          </div>
          <div>
            <h5 class="modal-title fw-bold mb-0" id="marcModalLabel">{{ 'MARCRecord' | translate }}</h5>
            <p class="text-muted small mb-0">{{ 'MARC' | translate }}</p>
          </div>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body p-0">
        <div class="marc-container">
          <!-- MARC Table View -->
          <div class="table-responsive" *ngIf="marc && marc.length > 0">
            <table class="table table-bordered table-hover marc-table align-middle mb-0">
              <thead class="table-light">
                <tr>
                  <th scope="col" class="col-tag text-center">{{ 'Tag' | translate }}</th>
                  <th scope="col" class="col-ind text-center">{{ 'Ind1' | translate }}</th>
                  <th scope="col" class="col-ind text-center">{{ 'Ind2' | translate }}</th>
                  <th scope="col" class="col-data">{{ 'SubfieldData' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tag of marc; let i = index" class="marc-row">
                  <!-- Tag ID -->
                  <td class="col-tag text-center">{{ tag.TagID }}</td>

                  <!-- Indicators -->
                  <ng-container *ngIf="tag.TagID !== 'Leader'; else noInd">
                    <td class="col-ind text-center" [attr.data-label]="'Ind1' | translate">
                      {{ tag.Indicator1 && tag.Indicator1.trim() !== '' ? tag.Indicator1 : '#' }}
                    </td>
                    <td class="col-ind text-center" [attr.data-label]="'Ind2' | translate">
                      {{ tag.Indicator2 && tag.Indicator2.trim() !== '' ? tag.Indicator2 : '#' }}
                    </td>
                  </ng-container>
                  <ng-template #noInd>
                    <td class="col-ind"></td>
                    <td class="col-ind"></td>
                  </ng-template>

                  <!-- Subfield Data -->
                  <td class="col-data" [innerHTML]="tag.Subfield"></td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Empty State -->
          <div *ngIf="!marc || marc.length === 0" class="marc-empty-state">
            <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
            <p class="text-muted">{{ 'NoMARCRecordsAvailable' | translate }}</p>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer bg-light border-0">
        <button type="button" class="btn btn-outline-secondary rounded-pill px-4" data-bs-dismiss="modal">
          <i class="bi bi-x-circle me-2"></i>
          {{ 'Close' | translate }}
        </button>
        <button type="button" class="btn btn-primary rounded-pill px-4" (click)="copyToClipboard()">
          <i class="bi bi-clipboard me-2"></i>
          {{ 'CopyMARC' | translate }}
        </button>
      </div>

    </div>
  </div>
</div>